/**
 * Form Serialize - Custom implementation
 * Serializes form data into a JavaScript object or URL-encoded string
 */

function serialize(form, options = {}) {
  if (!form || form.nodeName !== 'FORM') {
    throw new Error('First argument must be a form element');
  }

  const opts = {
    hash: false,
    empty: false,
    serializer: null,
    ...options
  };

  const elements = Array.from(form.elements);
  const data = {};

  elements.forEach(element => {
    // Skip disabled elements
    if (element.disabled) return;

    const name = element.name;
    if (!name) return;

    const type = element.type.toLowerCase();
    const tagName = element.tagName.toLowerCase();

    // Handle different input types
    switch (type) {
      case 'checkbox':
        if (element.checked) {
          addValue(data, name, element.value || 'on');
        }
        break;

      case 'radio':
        if (element.checked) {
          addValue(data, name, element.value);
        }
        break;

      case 'file':
        // Skip file inputs for security
        break;

      case 'submit':
      case 'button':
        // Skip submit and button elements
        break;

      default:
        // text, email, password, number, etc.
        if (tagName === 'select') {
          if (element.multiple) {
            // Multiple select
            Array.from(element.selectedOptions).forEach(option => {
              addValue(data, name, option.value);
            });
          } else {
            // Single select
            if (element.selectedIndex !== -1) {
              addValue(data, name, element.value);
            }
          }
        } else {
          // Regular input fields
          if (element.value !== '' || opts.empty) {
            addValue(data, name, element.value);
          }
        }
        break;
    }
  });

  // Apply custom serializer if provided
  if (opts.serializer && typeof opts.serializer === 'function') {
    return opts.serializer(data);
  }

  // Return as hash object or URL-encoded string
  if (opts.hash) {
    return data;
  } else {
    return toURLEncoded(data);
  }
}

function addValue(data, name, value) {
  if (data[name] === undefined) {
    data[name] = value;
  } else if (Array.isArray(data[name])) {
    data[name].push(value);
  } else {
    data[name] = [data[name], value];
  }
}

function toURLEncoded(data) {
  const pairs = [];
  
  Object.keys(data).forEach(key => {
    const value = data[key];
    if (Array.isArray(value)) {
      value.forEach(v => {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
      });
    } else {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  });
  
  return pairs.join('&');
}

// Export for both CommonJS and ES modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = serialize;
} else if (typeof window !== 'undefined') {
  window.serialize = serialize;
}
